import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { InventoryPage } from "../inventory/inventory";
import { CategoriesPage } from "../categories/categories";
import { PosTabsPage } from '../pos-tabs/pos-tabs';
import { Configuration } from '../../constants/config';
import {LoginPage} from "../login/login";
import {ReportsPage} from "../reports/reports";
import {SettingsPage} from "../settings/settings";

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

    constructor(public navCtrl: NavController, public _configuration: Configuration) {
        _configuration.actualModule=2;

        if (!this._configuration.isLogged){
            this.navCtrl.setRoot(LoginPage);
        }
    }

    logOut() {
        this.navCtrl.setRoot(LoginPage);
    }

    goToInventory() {
        this.navCtrl.push(InventoryPage);
    }

    goToCategories() {
        this.navCtrl.push(CategoriesPage);
    }

    goToPos() {
        this.navCtrl.setRoot(PosTabsPage);
    }

    goToReports() {
        this.navCtrl.push(ReportsPage);
    }

    goToSettings() {
        this.navCtrl.push(SettingsPage);
    }

}


// WEBPACK FOOTER //
// ./src/pages/home/home.ts